<fuse-loading-bar></fuse-loading-bar>

<fuse-vertical-navigation
    *ngIf="(userUiType !== 2 && userUiType !== 4) || isScreenSmall"
    class="dark dark:bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation?.default"
    [opened]="!isScreenSmall">
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <div class="flex items-center justify-center">
                <img
                    class="w-32"
                    ngSrc="../../../../../assets/images/altitude%20rewards/logo/ar-logo-no-slogan-1.png"
                    priority="true"
                    width="640" height="264">
            </div>
            <div class="flex items-center ml-auto">
                <notifications></notifications>
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <div class="flex flex-col items-center w-full p-4">
            <div class="flex flex-col items-center justify-center w-full mt-6">
                <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{user.ds_firstname}} {{user.ds_lastname}}
                </div>
                <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{user.ds_email}}
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-10">
            <img
                class="w-32"
                ngSrc="../../../../../assets/images/altitude%20rewards/logo/ar-logo-no-slogan-1.png"
                priority="true"
                width="640" height="264">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<div class="flex flex-col flex-auto w-full min-w-0">

    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">

        <button
            *ngIf="(userUiType !== 2 && userUiType !== 4) || isScreenSmall"
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:queue-list'"></mat-icon>
        </button>

        <ng-container *ngIf="userUiType === 2 || userUiType === 4">
            <div class="flex flex-0 items-center mr-4" routerLink="/dashboards/project">

                <img
                    *ngIf="userUiType === 4"
                    class="w-32"
                    ngSrc="../../../../../assets/images/altitude%20rewards/logo/Ambassador-seal-1.png"
                    priority="true"
                    width="640" height="264">

                <img
                    *ngIf="userUiType === 2"
                    class="w-32"
                    ngSrc="../../../../../assets/images/altitude%20rewards/logo/ar-logo-no-slogan-2.png"
                    priority="true"
                    width="640" height="264">
            </div>

            <div class="hidden md:flex items-center" *ngIf="!isScreenSmall">
                <fuse-horizontal-navigation [name]="'mainNavigation'" [navigation]="navigation?.default"></fuse-horizontal-navigation>
            </div>
        </ng-container>

        <div class="flex items-center ml-auto pl-2 space-x-1 sm:space-x-2">
            <ng-container *ngIf="userUiType === 2 || userUiType === 4">
                <div class="hidden lg:flex flex-col items-end mr-2">
                    <div class="text-sm font-medium leading-none">{{user.ds_firstname}} {{user.ds_lastname}}</div>
                    <div class="text-xs font-medium text-secondary leading-none mt-1">{{user.ds_email}}</div>
                </div>
                <notifications></notifications>
                <user></user>
            </ng-container>
        </div>
    </div>

    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <div class="relative flex flex-col items-start justify-start w-full px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <div class="font-extralight text-secondary">© 2025 Altitude Rewards, LLC. All Rights Reserved.</div>
        <div class="font-extralight text-secondary">"KIXA" and "KIXA Connect" are trademarks of Altitude Rewards, LLC.</div>
    </div>

</div>
